export default __webpack_public_path__ + "static/media/Sair Loading.51ef9796.svg";